<template>
    <div class="internal-resources-root">
        <Header :label="$t('resourcesInternal.header')" />

        <MainLayout marginTop>
            <ProfileModule slot="right" />
            <FeaturedResource slot="right" />
            <VerifyModule slot="right" />
            <WidgetModule slot="right" />
            <!-- <SectionHeader slot="center" style="position:relative">
                <Breadcrumb :trace="breadcrumb" slot="left" />
            </SectionHeader> -->

            <div slot="center">
                <Paper class="internal-resources-top-bar">
                    <div v-if="!!folder" class="internal-resources-folder-header">
                        <img :src="imageUrl" class="internal-resources-folder-header-image" />
                        <div class="internal-resources-folder-data-wrapper">
                            <h2 class="internal-resources-folder-data-title">
                                {{ folder.name }}
                            </h2>
                            <p class="internal-resources-folder-data-description">
                                {{ folder.description }}
                            </p>
                        </div>
                    </div>
                    <FileListModule v-if="hasItems" :is-loading="files === []" :files="files" />
                </Paper>
            </div>
            <NoContent
                v-if="!hasItems && !loading"
                slot="center"
                :caption="$t('resourcesInternal.resourceFolderNoContent')"
            ></NoContent>
            <div v-if="!hasItems && !loading" slot="center" class="text-center">
                <button class="btn btn-primary backbutton" @click="goBack">
                    {{ $t('general.back') }}
                </button>
            </div>
        </MainLayout>
    </div>
</template>

<script>
// Components
import Header from '~/components/layouts/Header';
import MainLayout from '~/components/layouts/mainlayout/MainLayout';
import ProfileModule from '~/components/smart/ProfileModule/ProfileModule';
import VerifyModule from '~/components/miscellaneous/VerifyModule';
import NoContent from '~/components/miscellaneous/NoContent';
import FeaturedResource from '~/components/smart/FeaturedResource';
import Paper from '../../../components/builders/Paper';
import ResourceService from '~/services/ResourceService';
import URLS from '~/URLS';
import FileListModule from './components/FileListModule';

// Assets
import FolderIcon from '~/assets/img/Folder-icon.png';
import WidgetModule from '~/components/smart/WidgetModule.vue';

export default {
    name: 'ResourcesInternalFolder',
    components: {
        FileListModule,
        Paper,
        Header,
        MainLayout,
        ProfileModule,
        VerifyModule,
        FeaturedResource,
        NoContent,
        WidgetModule,
    },
    data() {
        return {
            search: '',
            breadcrumb: [
                {
                    text: this.$t('resourcesInternal.header'),
                    to: URLS.internalResources,
                },
            ],
            files: [],
            emptyFolderIcon: FolderIcon,
            loading: true,
            folder: { name: '', description: '', thumbnail: undefined },
        };
    },
    computed: {
        folderID() {
            return this.$route.params.id;
        },
        hasItems() {
            return this.files.length > 0;
        },
        imageUrl() {
            if (this.folder && this.folder.thumbnail && this.folder.thumbnail.trim() !== '') {
                return this.folder.thumbnail;
            } else {
                return this.emptyFolderIcon;
            }
        },
    },
    methods: {
        loadFiles() {
            ResourceService.getFolderById(this.folderID).then(res => {
                this.files = res.data;
            });
        },
        loadFolder() {
            ResourceService.getFileById(this.folderID).then(res => {
                this.folder = res.data;
            });
        },
        goBack() {
            window.history.back();
        },
    },
    watch: {
        folderID: {
            async handler() {
                this.loading = true;
                await this.loadFolder();
                await this.loadFiles();
                this.loading = false;
            },
            immediate: true,
        },
        breadcrumb(newBreadCrumbs) {
            const lastIndex = newBreadCrumbs.length - 1;
            const lastAddedCrumb = newBreadCrumbs[lastIndex];
            // check if the crumb already exist
            const index = newBreadCrumbs
                .slice(0, lastIndex - 1)
                .findIndex(it => it.to == lastAddedCrumb.to);
            if (index != -1) {
                this.breadcrumb = newBreadCrumbs.slice(0, index + 1);
            }
        },
        folder(newFolder) {
            this.breadcrumb.push({
                text: newFolder.name,
                to: `${URLS.internalResources}/${newFolder.id}`,
            });
        },
    },
};
</script>

<style scoped>
.internal-resources-folder-header {
    display: grid;
    grid-template-columns: 1fr 3fr;
    grid-gap: 40px;
}
.internal-resources-folder-header-image {
    width: 100%;
    height: 120px;
    object-fit: contain;
    padding: 10px;
}
.internal-resources-root {
    padding-bottom: 100px;
}
.internal-resources-top-bar {
    overflow: hidden;
}
.internal-resources-folder-data-wrapper {
    padding: 20px;
}
.internal-resources-folder-data-title {
    font-size: 20px;
    font-weight: bold;
}
.internal-resources-folder-data-description {
    font-size: 12px;
    margin-bottom: 0;
}

.backbutton {
    width: auto;
}
</style>
